function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M19.531 17.969a2.336 2.336 0 00-2.2 1.562H7.67a2.338 2.338 0 00-2.2-1.562 2.345 2.345 0 000 4.687 2.336 2.336 0 002.2-1.562h9.662a2.338 2.338 0 004.544-.782 2.345 2.345 0 00-2.344-2.343zM5.469 2.344A5.475 5.475 0 000 7.813c0 2.806 4.388 7.776 4.888 8.334.148.164.359.26.58.26a.785.785 0 00.582-.26c.5-.558 4.888-5.528 4.888-8.334a5.475 5.475 0 00-5.47-5.47zm0 7.812a2.345 2.345 0 11.001-4.689 2.345 2.345 0 01-.001 4.69zM19.531 2.344a5.475 5.475 0 00-5.468 5.469c0 2.806 4.387 7.776 4.887 8.334.148.164.36.26.581.26a.785.785 0 00.582-.26c.5-.558 4.887-5.528 4.887-8.334a5.475 5.475 0 00-5.469-5.47zm0 7.812a2.345 2.345 0 11.002-4.689 2.345 2.345 0 01-.002 4.69z",
  fill: "#0685FE"
});

function SvgIconDistance(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    fill: "none"
  }, props), _ref);
}

export default SvgIconDistance;